import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import CreateProjectForm from "./CreateProjectForm";
import {
  setProjectDataAction,
  clearProjectDataAction
} from "../../actions/formData.action";
import { getProjectDetailByIdAction } from "../../actions/createProject.action";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { modifyDataForEdit } from "../createProject/helper";
import { getDivisionList } from "../../actions/common.action";

export class EditProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      march24DTO: null,
      superAdminPMGUserAdmin: false
    };
  }

  // getDivisionsData = async (sponsoringdeptId) => {
  //   const divResp = await getDivisionList(undefined, sponsoringdeptId);
  //   const { data, status } = divResp;
  //   if (status) {
  //     this.setState({
  //       divisionData: data.data,
  //     });
  //   }
  // };

  onHandleClose = () => {
    const { clearProjectDataDispatch, handleClose } = this.props;
    handleClose();
    clearProjectDataDispatch();
  };

  render() {
    const {
      show,
      previewData,
      data,
      onProjectEdit,
      iigProjectReferenceId,
      editData,
      isEdit
    } = this.props;
    return (
      <React.Fragment>
        <Modal
          show={show && editData}
          onHide={this.onHandleClose}
          className={`test-data-class-edit-project edit-project edit-new-project ${
            previewData && previewData.formType !== "DEFAULT"
              ? "edit-project-for-pp"
              : ""
          }`}
        >
          <Modal.Header closeButton />
          <Modal.Body>
            <CreateProjectForm
              isEdit={isEdit}
              onCloseModel={this.onHandleClose}
              onProjectEdit={onProjectEdit}
              pli={data["pliDTO"]["pli"]}
              projectId={data ? data.id : previewData && previewData.id}
              apiData={previewData}
              projectStatusWithRespectToIssueStatus={
                data && data.projectStatusWithRespectToIssueStatus
              }
              isIIGProject={data.iigPayload !== null}
              iigProjectReferenceId={iigProjectReferenceId}
              march24DTO={this.state.march24DTO}
              superAdminPMGUserAdmin={this.state.superAdminPMGUserAdmin}
            />
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    previewData: state.formReducer.previewData
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setProjectDataDispatch: setProjectDataAction,
      getProjectDetailByIdDispatch: getProjectDetailByIdAction,
      clearProjectDataDispatch: clearProjectDataAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProject);
